





































import { Component, mixins } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop } from 'vue-property-decorator'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import { DepartmentCollectionType } from '@/modules/department/models/department-collection.model'
import AdminDepartmentIndexPageTableRow
  from '@/modules/department/components/admin/table/AdminDepartmentIndexPageTableRow.vue'
import {
  adminDepartmentIndexPageTableColumn
} from '@/modules/department/models/columns/admin-department-index-page-table.column'
import { Filter, FilterTypes } from '@/modules/common/filter/filter'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminDepartmentCreateDialog from '@/modules/department/components/admin/AdminDepartmentCreateDialog.vue'
import AdminAgentSearchFilter from '@/modules/user/components/admin/AdminAgentSearch.filter.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'دپارتمان‌ها'
  },
  metaInfo: {
    title: 'دپارتمان‌ها'
  },
  components: {
    BaseButton,
    PaginationWithInput,
    TesTable,
    FilterRow
  }
})
export default class AdminDepartmentIndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  @Prop() departments: DepartmentCollectionType

  private rowComponent = AdminDepartmentIndexPageTableRow

  private columns = adminDepartmentIndexPageTableColumn()

  private filters = [
    new Filter({
      type: FilterTypes.Custom,
      title: 'پشتیبان',
      component: AdminAgentSearchFilter,
      key: 'supporters',
      props: {
        placeholder: 'جستجو پشتیبان',
        multiple: true
      }
    }),
    new Filter({
      type: FilterTypes.Toggle,
      key: 'active',
      title: 'فعال'
    })
  ]

  protected get model() {
    return this.departments
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }

  private openCreateDepartmentDialog() {
    this.$q.dialog({
      component: AdminDepartmentCreateDialog
    })
  }
}
